import React, {useState} from 'react';
import {useTheme} from "@mui/material/styles";
import {Box, Button, Divider, FormControl, Grid, IconButton, InputAdornment, Stack, Typography, useMediaQuery} from "@mui/material";
import AuthCardWrapper from "../AuthCardWrapper";
import Loader from "../../../utils/ui-components/Loader";
import {Link} from "react-router-dom";
import AuthRegister from "../auth-forms/auth-register";
import { Formik } from 'formik';
import * as Yup from 'yup';
import TextField from '../../../utils/ui-components/FormsUI/TextField';
import AnimateButton from '../../../utils/ui-components/AnimateButton';
import { openSuccessDialog } from '../../../utils/ui-components/pop-ups/SuccessDialog';
import * as api from "../../../assets/api/index";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import {strengthColor, strengthIndicator} from "../../../utils/utils";
import TaskAltIcon from '@mui/icons-material/TaskAlt';



function ForgotPassword() {
    const theme = useTheme();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));

    const [loading, setLoading] = useState(false);
    const [isSendEmail, setIsSendEmail] = useState(false)

    return (
        <Grid className="container">
            <Grid container direction="column" justifyContent="center" alignItems="center">
                <AuthCardWrapper>
                    <Grid container spacing={2} alignItems="center" justifyContent="center">
                        <Grid item container spacing={2} sx={{mb: 1}} alignItems="center" justifyContent="center">
                            <Grid item>
                                <img
                                    // height="65"
                                    width="180"
                                    src={require("../../../assets/images/logo-with-name.png")}
                                    alt="logo"/>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid
                                container
                                direction={matchDownSM ? 'column-reverse' : 'row'}
                                alignItems="center"
                                justifyContent="center">
                                <Grid item>
                                    <Stack alignItems="center" justifyContent="center" spacing={1}>
                                        <Typography
                                            color={theme.palette.primary.main}
                                            gutterBottom
                                            variant={matchDownSM ? 'h3' : 'h2'}
                                        >
                                            Forgot Password
                                        </Typography>
                                        <Typography
                                            variant="caption"
                                            fontSize="16px"
                                            textAlign={matchDownSM ? 'center' : 'inherit'}
                                        >
                                           Enter your username to continue
                                        </Typography>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                        {!isSendEmail && !loading &&
                            <Formik
                                enableReinitialize={true}
                                initialValues={{
                                    email: '',
                                }}
                                validationSchema={Yup.object().shape({
                                    email: Yup.string().email('Must be a valid email').max(255).required('Username is required')
                                })}
                                onSubmit={async (values, {setErrors, setStatus, setSubmitting} : any) => {
                                    try {
                                        setLoading(true)
                                        if (values) {
                                                    setStatus({success: true});
                                                    setSubmitting(true);
                            
                                                    const { data } = await api.forgotPassord(values);
                                                    if(data.status === "success"){
                                                        setLoading(false)
                                                        setIsSendEmail(true)
                                                    }
                                                }
                                            } catch (err: any) {
                                                setLoading(false)
                                                setStatus({success: false});
                                                setErrors({submit: err.message});
                                                setSubmitting(false);
                                            }
                                        }}
                                >
                                {({errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values}: any) => (
                                <form noValidate onSubmit={handleSubmit}>
                                        <TextField
                                            fullWidth
                                            label="Username"
                                            name="email"
                                            type="email"
                                            value={values.email}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            error={Boolean(touched.email && errors.email)}
                                            helperText={(touched.email && errors.email) && errors.email}
                                        />
                                        <Box sx={{mt: 2}}>
                                            <AnimateButton>
                                                <Button
                                                    disableElevation
                                                    disabled={isSubmitting}
                                                    fullWidth
                                                    size="large"
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                    sx={{color: "white", fontWeight: "bold"}}
                                                >
                                                Next
                                                </Button>
                                            </AnimateButton>
                                        </Box>
                                    </form>
                                )}
                            </Formik>
                        }
                        {isSendEmail && !loading && 
                        <Stack direction={'row'} spacing={2} alignItems={'center'} justifyContent={'center'}>
                            <TaskAltIcon color='success' />
                            <Typography>
                            Password reset link sent to your email. Please check.
                            </Typography>
                        </Stack>
                        }

                        </Grid>
                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>
                        <Grid item>
                            <Grid item container direction="column" alignItems="center" xs={12}>
                                <Typography
                                    component={Link}
                                    to="/login"
                                    variant="subtitle1"
                                    sx={{textDecoration: 'none'}}
                                >
                                    Back to login
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </AuthCardWrapper>
            </Grid>
            {loading && <Loader/>}
        </Grid>
    );
}

export default ForgotPassword;